import cn from '@/utils/cn';

type AvatarSize = 'sm' | 'md' | 'lg';

interface AvatarProps {
  name: string;
  size?: AvatarSize;
  className?: string;
}

const sizeStyles: Record<AvatarSize, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-9 w-9 text-sm',
  lg: 'h-11 w-11 text-base',
};

const initials = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase() || '?';

const Avatar = ({ name, size = 'md', className }: AvatarProps) => (
  <span
    className={cn(
      'inline-grid shrink-0 place-items-center rounded-full',
      'border border-brand/20 bg-brand-tint font-bold text-brand select-none',
      sizeStyles[size],
      className,
    )}
    aria-hidden
  >
    {initials(name)}
  </span>
);

export default Avatar;
